export class NumberHelper {
  public static leadingZero(numberValue: number): string | number {
    return numberValue < 10 ? '0' + numberValue : numberValue;
  }
}
